import { ProductsSeriesStore, ProductsSeriesActions } from './types';

export const defaultState: ProductsSeriesStore = {
  error: null,
  isLoading: false,
  isLoaded: false,
  productSeries: null,
};

const reducer = (
  state: ProductsSeriesStore = defaultState,
  action: { type: ProductsSeriesActions; payload?: any }
): ProductsSeriesStore => {
  const { FetchSeriesBegin, FetchSeriesError, FetchSeriesSuccess } = ProductsSeriesActions;
  switch (action.type) {
    case FetchSeriesBegin: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: null,
      };
    }
    case FetchSeriesError: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case FetchSeriesSuccess: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: null,
        ...action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
